<template>
  <v-tooltip top :max-width="`${maxWidth}px`">
    <template v-slot:activator="{ on, attrs }">
      <v-icon :size="size" v-bind="attrs" :color="color" v-on="on">
        mdi-help-circle
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'softTextGrey lighten-2',
    },
    size: {
      type: Number,
      default: 20,
    },
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
}
</script>
